import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      fontFamily: "'General Grotesque', Inter, 'Helvetica', 'sans-serif' !important",
      lineHeight: 'normal',
      letterSpacing: 'normal',
      // backgroundColor: '#F5F2ED', // To show behind nav menu when it's hidden
      [theme.breakpoints.up('md')]: {
        // display: 'flex',
        fontFamily: "'General Grotesque', Inter, 'Helvetica', 'sans-serif' !important",
      },
    },
    main: {
      paddingLeft: '35px',
      paddingRight: '35px',
    },
  }),
  { name: 'App' },
);

export default useStyles;
